<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-50">
    <div class="p-6 max-w-lg w-full bg-white rounded-2xl shadow-xl relative">
        <div class="mb-4 border-b border-blueGray-100 pb-3 flex justify-between items-center">
            <h2 class="font-bold text-xl text-primary-500">
                {{ data.event ? 'Edit Calendar Event' : 'Create Calendar Event' }}
            </h2>
            <button (click)="onCancel()" class="text-blueGray-400 hover:text-blueGray-600 focus:outline-none outline-none">
                <i class="fa fa-times text-lg"></i>
            </button>
        </div>

        <form [formGroup]="pageForm" (ngSubmit)="submit()" class="space-y-4">
            <!-- Event Name -->
            <div>
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                    Event Name *
                </label>
                <input type="text" formControlName="name" placeholder="e.g. Choir Practice, Youth Group Meetup" required
                    class="border border-blueGray-200 placeholder-blueGray-300 text-blueGray-600 bg-white rounded-lg text-sm shadow-sm focus:border-primary-500 focus:ring-0 w-full py-2.5 px-3 outline-none" />
                <div *ngIf="pageForm.get('name')?.invalid && (pageForm.get('name')?.dirty || pageForm.get('name')?.touched)"
                    class="pt-1 text-red-500 text-xs">
                    Event name is required (3-100 characters).
                </div>
            </div>

            <!-- Date & Time -->
            <div>
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                    Date & Time *
                </label>
                <input type="datetime-local" formControlName="date" required
                    class="border border-blueGray-200 placeholder-blueGray-300 text-blueGray-600 bg-white rounded-lg text-sm shadow-sm focus:border-primary-500 focus:ring-0 w-full py-2.5 px-3 outline-none" />
                <div *ngIf="pageForm.get('date')?.invalid && (pageForm.get('date')?.dirty || pageForm.get('date')?.touched)"
                    class="pt-1 text-red-500 text-xs">
                    Date and time is required.
                </div>
            </div>

            <!-- Description -->
            <div>
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                    Description (5000 Characters)
                </label>
                <textarea formControlName="description" placeholder="Description of the event..."
                    class="border border-blueGray-200 placeholder-blueGray-300 text-blueGray-600 bg-white rounded-lg text-sm shadow-sm focus:border-primary-500 focus:ring-0 w-full py-2.5 px-3 outline-none"
                    rows="4"></textarea>
            </div>

            <!-- Volunteers Toggle -->
            <div class="flex items-center gap-2 py-2">
                <input type="checkbox" id="requestVolunteers" formControlName="requestVolunteers"
                    class="rounded border-blueGray-300 text-primary-500 focus:ring-0 focus:ring-offset-0 focus:outline-none outline-none h-4 w-4" />
                <label for="requestVolunteers" class="text-sm font-semibold text-blueGray-700 cursor-pointer select-none focus:outline-none outline-none">
                    Request Volunteers for this Event
                </label>
            </div>

            <!-- Volunteer Fields (Always displayed, conditionally styled & read-only) -->
            <div class="space-y-4 p-4 bg-blueGray-50 border border-blueGray-200 rounded-lg shadow-inner transition-all duration-200"
                [ngClass]="{ 'opacity-50 bg-blueGray-100/50 border-dashed pointer-events-none': !pageForm.get('requestVolunteers')?.value }">
                <div>
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1"
                        [ngClass]="{ 'text-blueGray-400': !pageForm.get('requestVolunteers')?.value }">
                        Volunteers Required
                    </label>
                    <input type="number" formControlName="volunteersRequired"
                        [readOnly]="!pageForm.get('requestVolunteers')?.value"
                        class="border border-blueGray-200 placeholder-blueGray-300 text-blueGray-600 bg-white rounded-lg text-sm shadow-sm focus:border-primary-500 focus:ring-0 w-full py-2.5 px-3 outline-none" />
                </div>
                <div>
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1"
                        [ngClass]="{ 'text-blueGray-400': !pageForm.get('requestVolunteers')?.value }">
                        Eligibility & Criteria Description
                    </label>
                    <textarea formControlName="volunteerCriteria" placeholder="Criteria to be eligible to volunteer..."
                        [readOnly]="!pageForm.get('requestVolunteers')?.value"
                        class="border border-blueGray-200 placeholder-blueGray-300 text-blueGray-600 bg-white rounded-lg text-sm shadow-sm focus:border-primary-500 focus:ring-0 w-full py-2.5 px-3 outline-none"
                        rows="3"></textarea>
                </div>
            </div>

            <!-- Actions -->
            <div class="flex justify-end gap-3 pt-4 border-t border-blueGray-100">
                <button type="button" (click)="onCancel()" [disabled]="working"
                    class="px-4 py-2 text-sm font-semibold bg-white text-blueGray-700 border border-blueGray-200 rounded-lg hover:bg-blueGray-50">
                    Cancel
                </button>
                <button type="submit" [disabled]="pageForm.invalid || working"
                    class="px-5 py-2 text-sm font-bold bg-primary-500 text-white rounded-lg hover:bg-primary-600 shadow flex items-center gap-1.5 disabled:opacity-50">
                    <span *ngIf="working">
                        <i class="fa fa-spinner fa-spin"></i>
                        {{ data.event ? 'Saving...' : 'Creating...' }}
                    </span>
                    <span *ngIf="!working">
                        <i class="fa fa-save"></i>
                        {{ data.event ? 'Edit Event' : 'Create Event' }}
                    </span>
                </button>
            </div>
        </form>
    </div>
</div>
